module.exports = __webpack_public_path__ + "static/media/pe.20bd6f7b.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/pe.svg
// module id = 919
// module chunks = 0